import scrollToId from "@store/utilities/scrollToId";

const clickAnchor = (urlItem: string) => {
    // anchor takes precedence if both anchor and link specified
    // if an anchor is specified and its target exists, scroll to it
    const anchorElement = urlItem.substring(1);
    if (document.getElementById(anchorElement) && urlItem.startsWith("#")) {
        scrollToId(anchorElement);
    }
};

const clickLink = (history: any, isInShell: boolean | undefined, url: string) => {
    if (!url) {
        // do nothing if url is invalid
        return;
    }
    if (url.startsWith("http")) {
        if (isInShell) {
            return;
        }
        // in shell location
        window.location.href = url;
    } else {
        // page change
        history.push(url);
    }
};

function linkHasAnchor(urls: string[]) {
    return urls.some((urlItem: string) => typeof urlItem === "string" && urlItem !== "" && urlItem.startsWith("#"));
}

const onAnchorClick = (history: any, isInShell: boolean | undefined, ...urls: any[]) => {
    // any type used because arguments are spread
    if (!urls) {
        return;
    }

    for (const urlItem of urls) {
        if (urlItem) {
            if (linkHasAnchor(urls)) {
                // ignore page urls if array includes valid anchor
                if (urlItem.startsWith("#") && urlItem.length > 1) {
                    clickAnchor(urlItem);
                    break;
                } else {
                    clickLink(history, isInShell, urlItem);
                    break;
                }
            } else {
                clickLink(history, isInShell, urlItem);
                break;
            }
        }
    }
};

export default onAnchorClick;
